import React from "react";

const WebPages_Global = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Global</h1>
      <p>This is the WebPages Global page content.</p>
    </div>
  );
};

export default WebPages_Global;
